var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 87,
    viewBox: "0 0 52 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4353 20.1875V7.58801C34.5472 5.75291 33.5625 3.33598 33.5625 1.61278C33.5625 -0.110422 31.5484 0.00147849 31.5484 0.00147849H25.6851H24.7675H18.9042C18.9042 0.00147849 16.89 -0.110422 16.89 1.61278C16.89 3.33598 15.9054 5.75291 16.0173 7.58801V20.1651C16.0173 20.1651 15.6816 22.694 17.9642 22.694H24.7451C25.3046 22.694 25.6627 22.694 25.6627 22.694H32.4436C34.7486 22.694 34.3906 20.1651 34.3906 20.1651L34.4353 20.1875Z",
    fill: "#9E8959"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1014_4128",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 22,
    width: 18,
    height: 65
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7212 22.6494H16.7578V86.6315H33.7212V22.6494Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1014_4128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6124 16.2934H24.8515C21.156 16.2934 18.1602 19.2893 18.1602 22.9848V78.3509C18.1602 82.0465 21.156 85.0423 24.8515 85.0423H25.6124C29.308 85.0423 32.3038 82.0465 32.3038 78.3509V22.9848C32.3038 19.2893 29.308 16.2934 25.6124 16.2934Z",
    fill: "white",
    stroke: "#555555",
    strokeWidth: 1.55556,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2383 3.51514V19.0239",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4023 5.41699V19.0235",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0469 5.41699V19.0235",
    stroke: "white",
    strokeWidth: 1.67,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 44.9745V45.3701H31.8023V44.9745H27.0195Z",
    fill: "#004137"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 44.5293V44.727H31.8023V44.5293H27.0195Z",
    fill: "#004137"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 43.8862V44.084H31.8023V43.8862H27.0195Z",
    fill: "#004137"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 42.8237V43.0215H31.8023V42.8237H27.0195Z",
    fill: "#004137"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 41.9824V42.1802H31.8023V41.9824H27.0195Z",
    fill: "#004137"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 40.9198V41.3154H31.771V40.9198H26.9883Z",
    fill: "#004137"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 40.4501V40.6479H31.8023V40.4502L27.0195 40.4501Z",
    fill: "#004137"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 39.2139V39.832H31.771V39.2139H26.9883Z",
    fill: "#004137"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 38.1265V38.3243H31.8023V38.1265H27.0195Z",
    fill: "#004137"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 38.5702V38.9658H31.8023V38.5702H27.0195Z",
    fill: "#004137"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 45.8485V46.2441H31.8023V45.8485H27.0195Z",
    fill: "#004137"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 45.3784V45.5762H31.8023V45.3784H27.0195Z",
    fill: "#004137"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 67.6221V68.0177H31.771V67.6221H26.9883Z",
    fill: "#004137"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 67.1763V67.3741H31.771V67.1763H26.9883Z",
    fill: "#004137"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 66.5336V66.7314H31.771V66.5336H26.9883Z",
    fill: "#004137"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 65.4707V65.6684H31.771V65.4707H26.9883Z",
    fill: "#004137"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 64.6293V64.8271H31.771V64.6293H26.9883Z",
    fill: "#004137"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6084 57.236C22.6084 57.236 22.6365 57.1797 22.6647 57.1797H26.6081C26.6081 57.1797 26.6645 57.2078 26.6645 57.236V58.4331C26.6645 59.6725 25.8758 60.5034 24.6364 60.5034C23.397 60.5034 22.6084 59.6725 22.6084 58.4331V57.236ZM26.0166 57.8839H23.2844V58.4331C23.2844 59.2641 23.8196 59.8133 24.6505 59.8133C25.4814 59.8133 26.0166 59.2641 26.0166 58.4331V57.8839Z",
    fill: "#9E8959"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 54.6005V54.9961H31.8023V54.6005H27.0195Z",
    fill: "#004137"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 54.1553V54.3531H31.8023V54.1553H27.0195Z",
    fill: "#004137"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 53.5126V53.7104H31.8023V53.5127L27.0195 53.5126Z",
    fill: "#004137"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 52.4492V52.647H31.8023V52.4492H27.0195Z",
    fill: "#004137"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 51.6088V51.8066H31.8023V51.6088H27.0195Z",
    fill: "#004137"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 50.5453V50.9409H31.771V50.5453H26.9883Z",
    fill: "#004137"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 50.0767V50.2745H31.8023V50.0767H27.0195Z",
    fill: "#004137"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 48.8405V49.4586H31.771V48.8405H26.9883Z",
    fill: "#004137"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 47.7529V47.9507H31.8023V47.7529H27.0195Z",
    fill: "#004137"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 48.1967V48.5923H31.8023V48.1967H27.0195Z",
    fill: "#004137"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 46.9113V47.5294H31.8023V46.9113H27.0195Z",
    fill: "#004137"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 64.2261V64.6217H31.8023V64.2261H27.0195Z",
    fill: "#004137"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 63.7808V63.9786H31.8023V63.7808H27.0195Z",
    fill: "#004137"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 63.1381V63.3359H31.8023V63.1381H27.0195Z",
    fill: "#004137"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 62.0751V62.2729H31.8023V62.0752L27.0195 62.0751Z",
    fill: "#004137"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 61.2338V61.4316H31.8023V61.2338H27.0195Z",
    fill: "#004137"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 60.1713V60.5669H31.771V60.1713H26.9883Z",
    fill: "#004137"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 59.7021V59.8999H31.8023V59.7021H27.0195Z",
    fill: "#004137"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9883 58.4659V59.084H31.771V58.4659H26.9883Z",
    fill: "#004137"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 57.3779V57.5757H31.8023V57.3779H27.0195Z",
    fill: "#004137"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 57.8223V58.2179H31.8023V57.8223H27.0195Z",
    fill: "#004137"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 56.5367V57.1548H31.8023V56.5367H27.0195Z",
    fill: "#004137"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 55.474V55.8696H31.8023V55.474H27.0195Z",
    fill: "#004137"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 55.0039V55.2016H31.8023V55.0039H27.0195Z",
    fill: "#004137"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 37.2852V37.9033H31.8023V37.2852H27.0195Z",
    fill: "#004137"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 36.2227V36.6183H31.8023V36.2227H27.0195Z",
    fill: "#004137"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0195 35.752V35.9498H31.8023V35.752H27.0195Z",
    fill: "#004137"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M51.017 41.984C51.017 39.9254 50.2336 38.1216 48.6887 36.6219C43.1217 31.2193 29.367 31.5619 28.7755 31.5789V33.7895C28.9112 33.7847 42.2536 33.4581 47.1485 38.2114C48.2623 39.2929 48.8038 40.5264 48.8038 41.984C48.8038 43.4404 48.2626 44.6733 47.1495 45.7529C43.1951 49.5859 33.6367 50.0863 30.0382 50.135V48.3714L26.417 51.1855L30.0382 54V52.3523C33.8722 52.3125 44.1128 51.7764 48.6884 47.3424C50.2333 45.8458 51.017 44.0423 51.017 41.984Z",
    fill: "#F48474"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4443 47L46.9443 45V48L48.4443 47.5L50.4443 47L46.9443 50.5L43.4443 47Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7935 48.4731L50.2857 48.178L46.4917 44.0257L45.7935 48.4731Z",
    fill: "#F48474"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0088 47H26.5088V55H22.0088V47Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7225 51.7856C26.7225 53.039 25.8915 53.8559 24.6381 53.8559C23.3846 53.8559 22.5537 53.039 22.5537 51.7856C22.5537 50.5321 23.3846 49.7012 24.6381 49.7012C25.8915 49.7012 26.7225 50.5321 26.7225 51.7856ZM23.2579 51.7856C23.2579 52.6024 23.8071 53.1658 24.6381 53.1658C25.469 53.1658 26.0183 52.6165 26.0183 51.7856C26.0183 50.9546 25.469 50.4053 24.6381 50.4053C23.8071 50.4053 23.2579 50.9546 23.2579 51.7856Z",
    fill: "#9E8959"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2156 47.4905C24.2156 47.4905 24.2437 47.4342 24.2719 47.4342H24.7367C24.7367 47.4342 24.793 47.4623 24.793 47.4905V49.1946C24.793 49.1946 24.7648 49.265 24.7226 49.265C23.3846 49.251 22.5537 48.6454 22.5537 47.3778C22.5537 46.1666 23.3846 45.3779 24.6381 45.3779C25.8915 45.3779 26.7225 46.2089 26.7225 47.4623C26.7225 48.0961 26.5112 48.5608 26.1732 48.9129C26.145 48.9411 26.1169 48.927 26.1028 48.9129L25.6521 48.5468C25.6521 48.5468 25.638 48.5186 25.638 48.5045C25.638 48.4904 25.638 48.4763 25.6521 48.4623C25.807 48.2933 26.0324 47.913 26.0324 47.4482C26.0324 46.6173 25.4831 46.068 24.6522 46.068C23.8212 46.068 23.272 46.5891 23.272 47.3778C23.272 48.0257 23.5959 48.4341 24.2296 48.5468V47.4764L24.2156 47.4905Z",
    fill: "#9E8959"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2421 56.533C23.2421 56.533 23.228 56.5893 23.1858 56.5893H22.6647C22.6647 56.5893 22.6084 56.5612 22.6084 56.533V54.5754C22.6084 54.5754 22.6365 54.519 22.6647 54.519H26.6081C26.6081 54.519 26.6645 54.5472 26.6645 54.5754V55.1669C26.6645 55.1669 26.6363 55.2232 26.6081 55.2232H23.2421V56.533Z",
    fill: "#9E8959"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63281 42.016C1.63281 44.0746 2.41617 45.8784 3.96108 47.3778C9.52806 52.7807 23.4895 52.4266 24.0809 52.4092L24.0152 50.1973C23.8796 50.202 10.3961 50.5416 5.50125 45.7886C4.38754 44.7071 3.84601 43.4733 3.84601 42.016C3.84601 40.5596 4.38722 39.3267 5.5003 38.2471C9.45441 34.4141 21.3873 33.5224 24.9858 33.4737V35.3684L27.5121 32.8421L24.9858 30V31.5789C21.1518 31.6191 8.53701 32.2236 3.9614 36.6573C2.41649 38.1542 1.63281 39.9573 1.63281 42.016Z",
    fill: "#F48474"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0.944336 42H4.94434L5.94434 43.5L3.44434 45H2.44434L1.94434 46L0.944336 42Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64402 42.4631L1.19751 46.7262L6.48566 44.8101L2.64402 42.4631Z",
    fill: "#F48474"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M19 27.5L31.5 28L31.5088 35L19 36V27.5Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6061 31.6265H21.293V74.2541H31.6061",
    stroke: "#9E8959",
    strokeWidth: 1.37509
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5088 50.1445L22.5088 50.1992V52.5H21.5088H20.5088V50.1445Z",
    fill: "#F48474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.9bb00e7d29801a1e967cb7e037617941.svg";
export { ForwardRef as ReactComponent };